import { render, staticRenderFns } from "./FooterPartnersComponent.vue?vue&type=template&id=1c0265fe"
import script from "./FooterPartnersComponent.vue?vue&type=script&lang=js"
export * from "./FooterPartnersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports